<template>
  <div class="lobby w-[100lvw] h-[100lvh] bg-cw-orange flex flex-col">
    <div class="fixed top-[30px] right-[30px]">
      <BaseButton background-color="var(--color-cw-olive)" border-color="#323617" class="w-10 md:w-11 lg:w-12 h-10 md:h-9 lg:h-10 justify-center" @click="handleSoundToggle">
        <SpeakerMuteIcon v-if="!isSoundEnabled" class="w-5 h-5 md:w-6 md:h-6" />
        <SpeakerIcon v-else class="w-5 h-5 md:w-6 md:h-6" />
      </BaseButton>
    </div>
    <div class="flex-1 flex gap-x-20 lg:gap-x-24 xl:gap-x-28 justify-center items-center">
      <div class="bg-[#FFBA66] rounded-[18px] w-max text-center">
        <h1
          class="text-8xl lg:text-9xl xl:text-[160px] leading-[88px] lg:leading-[115px] xl:leading-[140px] font-bold *:text-[#FFE8CC] *:-tracking-[7px] *:lg:-tracking-[10px] *:xl:-tracking-[14px] scale-105 mr-0.5"
        >
          <span class="block rotate-[5.492deg]">Plan</span>
          <span class="block -rotate-[1.864deg]">Save</span>
          <span class="block rotate-[4.562deg]">Invest</span>
        </h1>
      </div>
      <div class="grid grid-cols-1 gap-y-7 *:!w-full">
        <BaseButton background-color="#1AA570" border-color="var(--color-cw-green-border-shadow)" class="px-6 py-3.5" @click="registerModalRef?.open">
          <p class="w-full !text-base xl:!text-xl">Create an account</p>
        </BaseButton>
        <BaseButton background-color="var(--color-cw-indigo)" border-color="#1F2547" class="px-6 py-3.5" @click="loginModalRef?.open">
          <p class="w-full !text-base xl:!text-xl">Login</p>
        </BaseButton>
      </div>
    </div>
    <div class="px-[30px] pb-[30px] flex justify-center">
      <p class="mb-1.5 text-sm lg:text-base">A game by YellowCowries</p>
    </div>
    <LoginModal ref="loginModalRef" @open-reset-password="resetPasswordModalRef?.open()" />
    <RegisterModal ref="registerModalRef" />
    <ResetPasswordModal ref="resetPasswordModalRef" />
  </div>
</template>

<script setup lang="ts">
import { useTemplateRef } from 'vue'
import BaseButton from '@/components/base/BaseButton.vue'
import LoginModal from '@/components/modals/auth/LoginModal.vue'
import RegisterModal from '@/components/modals/auth/RegisterModal.vue'
import ResetPasswordModal from '@/components/modals/auth/ResetPasswordModal.vue'
import SpeakerIcon from '@/assets/svgs/icons/speaker-simple-high-fill.svg'
import SpeakerMuteIcon from '@/assets/svgs/icons/speaker-simple-x-fill.svg'
import { useAppStore } from '@/stores/app'
import { storeToRefs } from 'pinia'

const loginModalRef = useTemplateRef('loginModalRef')
const registerModalRef = useTemplateRef('registerModalRef')
const resetPasswordModalRef = useTemplateRef('resetPasswordModalRef')
const { toggleSound } = useAppStore()
const { isSoundEnabled } = storeToRefs(useAppStore())

const handleSoundToggle = () => {
  toggleSound()
}
</script>

<style scoped>
.lobby {
  background-image: url('@/assets/images/spiral.svg'), url('@/assets/images/noise-texture.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>
